<script>
import Loader from "@/components/widgets/loader";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { useStore } from "@/state/pinia_store.js";

import {getShowEquity} from '@/api/user'
/**
 * Starter component
 */
export default {
  page: {
    title: "账户概览",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader},
  props: {
    updating: {
      type: Boolean,
    },
  },
  data() {
    return {
      // stores: useStore(),
      u_title: "资管u本位账户",
      btc_title: "资管btc本位账户",
      cta_title: "自营cta账户",
      items: [
        {
          text: "Utility",
          href: "/"
        },
        {
          text: "Starter Page",
          active: true
        }
      ],
      equityoption: {
        backgroundColor: '#2A3042',
        title: {
          text: '',
          left: 'center'
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: false
            },
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          bottom: 90
        },
        dataZoom: [
          {
            type: 'inside'
          },
          {
            type: 'slider'
          }
        ],
        xAxis: {
          data: [],
          silent: false,
          splitLine: {
            show: false
          },
          splitArea: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          scale:true,
          splitArea: {
            show: false
          }
        },
        series: [
          {
            type: 'line',
            data: [],
            // Set `large` for large data amount
            large: true
          }
        ]
      },
      u_equitydata: [],
      u_equitydate: [],
      base_equity: 0,
      latest_value: 0,
      trade_days: 0,
      month_profit: 0,
      year_profit: 0,
      total_profit: 0,
      is_btc: 0,
    };
  },
  methods: {
    onResize(e) {
      this.u_equityChart_ = this.$echarts.init(document.getElementById('u_equityChart'),'dark')
      this.u_equityChart_.resize()
    },
    showEquityShow() {
      getShowEquity(this.alias).then((res) => {
      let u_res = res

      //u_client
      this.base_equity = u_res["base_equity"]
      this.latest_value = u_res["value"]
      this.trade_days = u_res["trade_days"]
      this.month_profit = u_res["month_profit"]
      this.year_profit = u_res["year_profit"]
      this.total_profit = u_res["total_profit"]
      this.is_btc = u_res["is_btc"]

      this.u_equityChart_ = this.$echarts.init(document.getElementById('u_equityChart'),'dark')

      this.u_equitydata = []
      this.u_equitydate = []

      for (let i = 0; i < u_res["equity_list"].length; ++i) {
        this.u_equitydata.push(parseFloat(u_res["equity_list"][i]['value']))
        this.u_equitydate.push(u_res["equity_list"][i]['date'])
      }

      console.log('equitydata')
      console.log(this.equitydata)

      this.equityoption.xAxis.data = this.u_equitydate
      this.equityoption.series[0].data = this.u_equitydata
      this.equityoption.title.text = "PnL"

      this.u_equityChart_.setOption(this.equityoption)


      }).catch((error) => {
        console.log(error)
      })
    },
    checkAccount() {
      if (this.$route.query.alias)
      {
        if (this.$route.query.alias != this.alias)
        {
          this.alias = this.$route.query.alias
          this.showEquityShow()
        }
      }
    }
  },
  mounted() {
    // console.log("hh")
    this.alias = this.$route.query.alias
    console.log(this.alias)
    if (!this.alias) {
      console.log("to default hhh")
      this.alias = localStorage.getItem("default_alias")
      let default_url = localStorage.getItem('default_url');
      this.$router.push(default_url)
    }

    this.my_timer = setInterval(this.checkAccount, 100)
    this.showEquityShow()
  },
  destroyed(){
  },
  beforeDestroy(){
    clearInterval(this.my_timer)
  }
};
</script>
<template>
  <Layout>
    <PageHeader
      :title="u_title"
    />

    <div class="row">
      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-copy-alt" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                初始金额
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4 >
                {{base_equity}}
                <!-- <i v-if="Aum >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" /> -->
              </h4>
              <!-- <div class="d-flex">
                <span v-if="MonthProfit >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{MonthProfit}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{MonthProfit}}</span>
                <span class="ml-2 text-truncate">7日年化收益</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-archive-in" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                最新净值
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4>
                    {{latest_value}}
                <!-- <i v-if="YearProfit >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" /> -->
              </h4>
              <!-- <div class="d-flex">
                <span v-if="YearProfit >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{YearProfit}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{YearProfit}}</span>
                <span class="ml-2 text-truncate">30日年化收益</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-archive-in" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                交易天数
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4>
                    {{trade_days}}
                <!-- <i v-if="YearProfit >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" /> -->
              </h4>
              <!-- <div class="d-flex">
                <span v-if="YearProfit >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{YearProfit}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{YearProfit}}</span>
                <span class="ml-2 text-truncate">30日年化收益</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>

     

      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-archive-in" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                本月收益
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4>
                {{month_profit}}
                <!-- <i v-if="MonthProfit >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" /> -->
              </h4>
              <!-- <div class="d-flex">
                <span v-if="YearProfit >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{YearProfit}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{YearProfit}}</span>
                <span class="ml-2 text-truncate">30日年化收益</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-purchase-tag-alt" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                本年收益
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4>
                {{year_profit}}
                <!-- <i v-if="YearProfit >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" /> -->
              </h4>

              <!-- <div class="d-flex">
                <span v-if="TotalProfit >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{TotalProfit}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{TotalProfit}}</span>
                <span class="ml-2 text-truncate">年化收益</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-purchase-tag-alt" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                累计收益
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4>
                {{total_profit}}
                <!-- <i v-if="TotalProfit >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" /> -->
              </h4>

              <!-- <div class="d-flex">
                <span v-if="TotalProfit >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{TotalProfit}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{TotalProfit}}</span>
                <span class="ml-2 text-truncate">年化收益</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="row" v-resize @resize="onResize">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
            累计净值
            </h4>
            <div id="u_equityChart" style="height:400px;">
            </div>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>